var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"top-title"},[_c('div',{staticClass:"item i-left"},[_vm._t("topLeft")],2),_c('div',{staticClass:"center"},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")]),_c('div',{staticClass:"item i-right"},[_vm._v("\n        "+_vm._s(_vm.nowDate + ' ' + _vm.nowWeek + ' ' + _vm.nowTime)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }